import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ClaimService, GlobalConstants } from '@app-core';
import { Claim } from '@app-models';
import { EmployerResponseJobRelocationComponent } from 'app/employer-response-job-relocation/employer-response-job-relocation.component';
import { EmployerResponseUnemploymentComponent } from 'app/employer-response-unemployment/employer-response-unemployment.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-employer-response',
    imports: [EmployerResponseUnemploymentComponent, EmployerResponseJobRelocationComponent],
    templateUrl: './employer-response.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './employer-response.component.scss',
})
export class EmployerResponseComponent {
    private readonly claimService = inject(ClaimService);
    private claimSubscription: Subscription;
    claimTypes = GlobalConstants.CLAIM_TYPE;
    claim: Claim | null = null;
    claimType: string | null = null;

    ngOnInit(): void {
        this.fetchClaimData();
    }

    fetchClaimData(): void {
        this.claimSubscription = this.claimService.getCurrentClaim().subscribe((claim: Claim) => {
            if (claim) {
                this.claim = claim;
                this.claimType = this.claim.claimType;
            }
        });
    }
}
